import React, { useState } from "react";
import { Feeds, Footer, Header } from "../";
import {
  BiSearchAlt,
  BiXCircle,
  FaAlgolia,
  FaDiscord,
} from "../../assets/icons/index";

import { Search } from "../";
import { motion } from "framer-motion";
import { fadeInOut } from "../../utils/animations";

const Home = () => {
  const [category, setCategory] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isDiscord, setIsDiscord] = useState(false);

  return (
    <div className="w-full h-auto flex flex-col items-center justify-center">
      <Header />

      <div className="w-full p-4 bg-slate-100 h-20 flex items-center justify-center mb-12">
        <div className="flex relative items-center justify-center gap-3 w-full md:w-656 bg-white mt-20 rounded-md shadow-lg px-4 py-2">
          <BiSearchAlt className="-rotate-12 text-2xl text-textColor" />
          <input
            type="text"
            className=" px-2 py-2 bg-transparent outline-none border-none w-full text-lg text-textColor font-semibold"
            placeholder="search here"
            onFocus={() => setIsFocused(true)}
          />
          <div className=" flex items-center absolute bottom-2 right-2 gap-2 ">
            <p className="text-base text-textColor">Search By: </p>
            <div className=" flex items-center gap-1">
              <FaAlgolia className="-rotate-0 text-lg text-blue-500" />
              <p className="text-base text-textColor">algolia</p>
            </div>
          </div>
        </div>
      </div>

      {/* All Feeds */}
      <Feeds />

      <a
        href="https://discord.gg/TsydV9XUJe"
        className=" fixed z-50 bottom-32 right-8 px-4 py-2  rounded-md flex  items-start
         gap-3 bg-blue-400 shadow-lg"
        target="_blank"
        onMouseEnter={() => setIsDiscord(true)}
        onMouseLeave={() => setIsDiscord(false)}
      >
        <FaDiscord className=" -rotate-0 text-4xl text-primary" />
        {isDiscord && (
          <motion.p
            {...fadeInOut}
            className="text-base text-textColor w-44 absolute bottom-16 -left-24 backdrop-blur-lg px-3 py-2 bg-card font-semibold rounded-md shadow-md"
          >
            {" "}
            Join our community
          </motion.p>
        )}
      </a>

      <Footer />

      {isFocused && <Search setIsFocused={setIsFocused} />}
    </div>
  );
};

export default Home;
